import { createAsyncThunk } from '@reduxjs/toolkit'
import { goodsKnowledge, getTypePrefix } from '@/api'
import okHttp from '@helper/okHttp'

/**
 * 获取商品知识库详情
 * @returns {Promise<void>}
 */
export const getRobotGoodsDetailAction = createAsyncThunk(
    getTypePrefix(goodsKnowledge.getRobotGoodsDetail),
    async (data) => await okHttp(goodsKnowledge.getRobotGoodsDetail, { 
        method: 'POST', 
        data 
    })
)

/**
 * 商品知识库详情 - 修改商品基本属性
 * @returns {Promise<void>}
 */
export const modifyCustomAttributeAction = createAsyncThunk(
    getTypePrefix(goodsKnowledge.modifyCustomAttribute),
    async (data) => await okHttp(goodsKnowledge.modifyCustomAttribute, { 
        method: 'POST', 
        data 
    })
)